import React from "react";
import Alert from "features/shared/alerts/components/Alert";
import { useTranslation } from "react-i18next";

const DepositAgreementNoContentAlert = () => {
  const t = useTranslation("depositAgreement\\depositAgreement").t;

  return (
    <Alert
      alertObj={{
        alertType: "Info",
        message: t("depositAgreementNoContentAlert.noContent"),
      }}
    />
  );
};

export default DepositAgreementNoContentAlert;
